<button
  class="{{(classList ? classList.join(' ') : '')}} {{(classListMobile && deviceService.isMobile() ? classListMobile.join(' ') : '')}}"
  [disabled]="disabled || loading"
  (click)="clickEvent.emit()"
  [type]="isSubmit ? 'submit' : 'button'"
  [ngClass]="{'small-button':getClass(isSmallButton,'small-button'),'secondary':getClass(isSecondary,'secondary'),'accent':getClass(isAccent,'accent'),
        'accent-secondary':getClass(isAccentSecondary,'accent-secondary'),'outlined':getClass(isOutlined,'outlined'),'plain':getClass(isPlain,'plain'),
        'full-width': getClass(fullWidth,'full-width'),'align-icon-right':getClass(alignIconRight,'align-icon-right'),
        'mobile-shrink':getClass(mobileShrink,'mobile-shrink') && deviceService.isMobile()}">
  <mat-icon *ngIf="icon" [ngClass]="{'hide':loading}">{{icon}}</mat-icon>
  <em *ngIf="nvIcon" class="icon-{{nvIcon}}" [ngClass]="{'hide':loading}"></em>
  <span *ngIf="text" [ngClass]="{'hide':loading}">{{ text }}</span>
  <ng-content [ngClass]="{'hide':loading}"></ng-content>
  <span *ngIf="loading && !isDottedLoader" class="button-loading-spinner"></span>
  <div class="dotted-loader" *ngIf="loading && isDottedLoader">
    <span></span><span></span><span></span>
  </div>
</button>
